// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmbedDarts_wrapper__07jCG"};